import './c-faq-list.scss';
import template from './faq-list.vhtml';

export default {
	template,
	data() {
		return {
			faqEl: [],
		};
	},
	mounted() {
		this.faqEl = this.$children;

		// Add events
		this.faqEl.forEach( el => {
			el.$on( 'selected', uid => {
				this.faqEl.forEach( el => {
					el.$data.isSelected = ( el._uid === uid || el.$data.isSelected === true );
				});
			});
		});


	},
	methods: {

	},
};



// WEBPACK FOOTER //
// ./assets/_js/components/faq-list/faq-list.js